import PropTypes from 'prop-types';
import React from 'react';
import FileUpload from 'common/form/FileUpload';
import ConsentDropzoneMessage from './ConsentDropzoneMessage';

const ConsentFileUpload = ({ name, document, type }) => (
  <FileUpload
    id="consent-file-upload"
    name={name}
    file={document}
    className="dropzone"
  >
    <ConsentDropzoneMessage type={type} />
  </FileUpload>
);

ConsentFileUpload.propTypes = {
  name: PropTypes.string.isRequired,
  document: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
};

ConsentFileUpload.defaultProps = {
  document: {
    onChange: () => (true),
  },
};

export default ConsentFileUpload;
